// The picture-day signup page.
//
// `Registration.jsx` beside this is the Bootstrap-3 page it replaced. Kept for
// now rather than deleted, because it is the only caller of
// /customer_registrations from the customer app and removing it is a separate
// job from building this one.
//
// It carries a `?retake=true` branch, but nothing links to it: the live retake
// request is the ERB flow at /customer_registrations/retake_request, which this
// change does not touch. Verified by grep before switching the route over.
import PictureDayRegistration from './PictureDayRegistration';

export default PictureDayRegistration;
